import { useCurrentStateAndParams } from "@uirouter/react";

import { useCategoriesComparison } from "app/pages/industry-analysis/categories-context/CategoriesContext";
import DurationService, { BasicDurations } from "app/services/DurationService";

import { ConversionRateComparisonOverview } from "./comparison/overview/ConversionRateComparisonOverview";
import { ConversionRateComparisonOverviewPop } from "./comparison/overview-pop/ConversionRateComparisonOverviewPop";
import { getConversionRateAvailability } from "./shared/getConversionRateAvailability";
import { ConversionRateOverview } from "./single/overview/ConversionRateOverview";
import { ConversionRateOverviewPop } from "./single/overview-pop/ConversionRateOverviewPop";

export const ConversionRateOverviewContainer = () => {
    const availabilityState = getConversionRateAvailability();
    const { categories, primaryCategory, isComparisonMode } = useCategoriesComparison();
    const { params } = useCurrentStateAndParams();

    if (availabilityState === "hidden" || !primaryCategory) {
        return null;
    }

    const isPeriodOverPeriod = DurationService.isPeriodOverPeriod();
    const durationParam = (params.duration as string) ?? BasicDurations.LAST_MONTH;
    const is28DaysDuration = durationParam === BasicDurations.LAST_TWENTY_EIGHT_DAYS;

    if (isComparisonMode) {
        if (is28DaysDuration) {
            return null;
        }
        return isPeriodOverPeriod ? (
            <ConversionRateComparisonOverviewPop
                categories={categories}
                availabilityState={availabilityState}
            />
        ) : (
            <ConversionRateComparisonOverview
                categories={categories}
                availabilityState={availabilityState}
            />
        );
    }

    if (isPeriodOverPeriod) {
        return (
            <ConversionRateOverviewPop
                primaryCategory={primaryCategory}
                availabilityState={availabilityState}
            />
        );
    }

    return (
        <ConversionRateOverview
            primaryCategory={primaryCategory}
            availabilityState={availabilityState}
        />
    );
};
